<template>
  <b-container fluid>
    <b-row>
      <b-col md="9">
        <b-form ref="form" @submit.stop.prevent="sendModalData">
          <h4 class="mb-4 mt-4">Создание организации</h4>
          <b-row>
            <b-col md="4">
              <b-form-group id="opf"
                            :invalid-feedback="getError('opf')">
                <b-form-select
                  id="opf"
                  name="opf"
                  v-model="opf_selected"
                  :options="opfOptions"
                  text-field="short_name"
                  value-field="short_name"
                  data-vv-as="ОПФ"
                  v-validate="{required:true}"
                  :state="validateState('opf')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group id="full_group_name"
                            :invalid-feedback="getError('full_group_name')">
                <b-form-input
                  id="full_group_name"
                  name="full_group_name"
                  required
                  placeholder="Введите наименование"
                  v-model="form.full_group_name"
                  data-vv-as="Наименование"
                  v-validate="{required:true}"
                  :state="validateState('full_group_name')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group id="id_group"
                            :invalid-feedback="getError('id_group')">
                <b-form-select
                  id="id_group"
                  name="id_group"
                  v-model="group_options_selected"
                  :options="form.id_group_options"
                  text-field="text"
                  value-field="value"
                  data-vv-as="Группа"
                  v-validate="{required:true}"
                  :state="validateState('id_group')"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <h4 class="mb-4 mt-4">Создание пользователя</h4>
          <b-button class="mb-4 mr-4" variant="success" size="sm" pill @click="addUser">
            <font-awesome-icon icon="plus"/>
          </b-button>
          <b-button class="mb-4" variant="warning" size="sm" pill @click="removeUser">
            <font-awesome-icon icon="minus"/>
          </b-button>
          <b-row class="mb-4" v-for="(user, index) in form.users" :key="index">
            <b-col md="4">
              <b-form-group :id="'full_user_name_' + index"
                            :invalid-feedback="getError('full_user_name_' + index)">
                <b-form-input
                  :id="'full_user_name_' + index"
                  :name="'full_user_name_' + index"
                  required
                  placeholder="Введите ФИО"
                  v-model="user.full_user_name"
                  data-vv-as="ФИО"
                  v-validate="{required:true}"
                  :state="validateState('full_user_name_' + index)"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :id="'username_' + index"
                            :invalid-feedback="getError('username_' + index)">
                <b-form-input
                  :id="'username_' + index"
                  :name="'username_' + index"
                  required
                  placeholder="Введите логин"
                  v-model="user.username"
                  data-vv-as="Логин"
                  v-validate="{required:true}"
                  :state="validateState('username_' + index)"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :id="'password_' + index"
                            :invalid-feedback="getError('password_' + index)">
                <b-form-input
                  :id="'password_' + index"
                  :name="'password_' + index"
                  required
                  placeholder="Введите пароль"
                  v-model="user.password"
                  data-vv-as="Пароль"
                  v-validate="{required:true}"
                  :state="validateState('password_' + index)"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button 
            class="float-right"
            variant="success"
            type="submit"
            :disabled="loading">
            ПЫЩ
          </b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'OtvtOrganizations',
  data () {
    return {
      loading: false,
      opf_selected: null,
      group_options_selected: '20200',
      form: {
        // opf_options: this.opfOptions,
        full_group_name: null,
        id_group_options: [
          { value: '20200', text: 'Контрагент (20200)' }
        ],
        users: [{
          full_user_name: null,
          username: null,
          password: null
        }]
      },
      form_data: {}
    }
  },
  mounted () {
    this.form.users[0].password = this.generatePassword()
    this.getOpfs()
  },
  methods: {
    addUser () {
      this.form.users.push({
        full_user_name: null,
        username: null,
        password: this.generatePassword()
      })
    },
    removeUser () {
      this.form.users.splice(-1, 1)
    },
    sendModalData (event) {
      event.preventDefault()
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.form_data.otvt_groups = {
            opf: this.opf_selected,
            full_group_name: this.form.full_group_name,
            id_group: this.group_options_selected
          }
          this.form_data.otvt_users = this.form.users
          this.loading = true
          await new Promise((resolve, reject) => {
            axios.post('/api/private/v4.0/user-group/manager/', { 
              ...this.form_data
            })
            .then(() => {
              this.makeToast('success', 'Группа с пользователями успешно создана!', 'Success')
              resolve()
              this.loading = false
            })
            .catch(error => {
              reject(error)
              this.loading = false
            })
          })
        }
      })
    },
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    generatePassword () {
      const length = 8
      const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let retVal = ''
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      return retVal
    },
    makeToast (variant = null, content = '', title = '') {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    ...mapActions('otvtOrganizations', ['getOpfs']),
  },
  computed: {
    ...mapState(
      {
        opfOptions: state => state.otvtOrganizations.opfOptions,
      }
    )
  }
}
</script>

<style scoped>

</style>
